import React from 'react';
import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { Empty, Spin } from 'antd';
import { RenderForm } from '../forms';
import TableComponent from '../table';
import { useCustomerHistory } from './useCustomerHistory';
import {
  customerHistoryColumns,
  customerHistoryExportHeaders,
  CustomerWarrantyClaimsTable,
  getClaimCountRowClass,
  toCustomerHistoryExportRows,
} from './customerHistoryColumns';
import ButtonExcelEmbedded from '../report-excel/ButtonExcelEmbedded';
import { ContainerButton } from '../../styles/global-style';
import {
  FORM_CUSTOMER_HISTORY_FILTER,
  customerHistoryFilterDefaultValues,
} from './customerHistoryFilter';
import { StyledCustomerHistory } from './styles';

export const CustomerHistory = ({ record }) => {
  const { control, setValue, getValues } = useForm({
    defaultValues: customerHistoryFilterDefaultValues(),
  });
  const customerCode = record?.customerCode || '';
  const expired = useWatch({ control, name: 'expired' });

  const { histories, loading, onFetchHistories } = useCustomerHistory({ customer: record });

  // ดึงใหม่ทุกครั้งที่เปลี่ยนตัวกรองสถานะประกัน
  useEffect(() => {
    onFetchHistories({ expired });
  }, [record?.customerCode, expired]);

  return (
    <div>
      <RenderForm
        control={control}
        setValue={setValue}
        getValues={getValues}
        forms={FORM_CUSTOMER_HISTORY_FILTER}
      />
      <Spin spinning={loading}>
        {histories.length ? (
          <StyledCustomerHistory>
            <ContainerButton right>
              <ButtonExcelEmbedded
                title="Export"
                header={customerHistoryExportHeaders}
                data={toCustomerHistoryExportRows(histories)}
                filename={`ประวัติลูกค้า-${customerCode}`}
              />
            </ContainerButton>
            <TableComponent
              rowKey="warrantyId"
              columns={customerHistoryColumns}
              dataSource={histories}
              hasPagination
              rowClassName={getClaimCountRowClass}
              expandable={{
                expandedRowRender: (warrantyRecord) => (
                  <CustomerWarrantyClaimsTable record={warrantyRecord} />
                ),
                rowExpandable: () => true,
              }}
            />
          </StyledCustomerHistory>
        ) : (
          <Empty description="ไม่มีรายการลงทะเบียน" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Spin>
    </div>
  );
};
